import { isNvrSupportSinglePc } from "lib/utils";
import { forwardRef, useEffect, useState } from "react";
import SinglePcCameraPlayer from "./single-pc-camera-player";
import CameraPlayer from "./camera-player";

export const UsingCameraPlayer = forwardRef((props: any, ref) => {
  const [supportSinglePc, setSupportSinglePc] = useState(null);
  useEffect(() => {
    if (!props.streamingCamera) return;
    isNvrSupportSinglePc(props.streamingCamera.nvrId).then(
      (supportSinglePc) => {
        setSupportSinglePc(supportSinglePc);
      },
    );
  }, [props.streamingCamera]);
  if (supportSinglePc === null) return null;
  return supportSinglePc ? (
    <SinglePcCameraPlayer {...props} ref={ref} />
  ) : (
    <CameraPlayer {...props} ref={ref} />
  );
});
